import { render, staticRenderFns } from "./NewUserWelcome.vue?vue&type=template&id=44fa727a&"
import script from "./NewUserWelcome.vue?vue&type=script&lang=js&"
export * from "./NewUserWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports